<template>
    <dash
        icon="fa fa-plus-circle"
        titulo="ADITIVOS SGF"
        subTitulo="GESTOR"
        @click.native="$router.push({ name: 'Gestores_SolicitacoesAditivos' })"
        :qtd="qtd"
        :mostrarQtd="false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
